import moment from "moment";
import { Line } from "rc-progress";
import React, { useState } from "react";
import { PulseLoader } from "react-spinners";
import { useAppUser } from "../../../../../../../contexts/user-context/UserContext";
import { useWorkShop } from "../../../../../../../contexts/workshop-context/WorkshopContext";
import "./styles.scss";

interface IProps {
  isArchived: boolean;
}
const PageHeader = (props: IProps) => {
  const appUser = useAppUser();
  const workshop = useWorkShop();
  const [loading, setLoading] = useState(false);

  return (
    <div className="std-page-header-wrapper ">
      <div className="blue-line ">
        <div className="text-left title">
          <div className="header-text text-truncate">{workshop.title}</div>
        </div>

        <div className="d-flex button justify-content-end">
          <div style={{ width: "250px", color: "#fff", paddingLeft: "30px" }}>
            <div style={{ fontSize: "18px", color: "#f9fafc" }}>
              Due Date: {moment(workshop.endDate).format("DD/MM/YYYY")}
            </div>
            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
              Points: {workshop.points}
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          color: "#777777",
          padding: "20px",
          paddingLeft: "40px",
          paddingRight: "40px",
          textAlign: "justify",
          flex: "1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <span
          className="small-scroll"
          style={{
            fontSize: "18px",
            color: "#777777",
            height: "110px",
            overflow: "auto",
            paddingRight: "10px",
          }}
        >
          {workshop.description}
        </span>
        {appUser.workshopProgress &&
        appUser.workshopProgress.filter((w) => w.workshopId === workshop.id)
          .length > 0 ? (
          <div className="xstudent-progress-bar">
            <label className="pcntg" style={{ fontSize: "14px" }}>
              {workshop.workshopProgress}%
            </label>
            <label className="label-text" style={{ fontSize: "14px" }}>
              Workshop progress
            </label>
            <div>
              <Line
                percent={workshop.workshopProgress}
                strokeWidth={0.5}
                trailWidth={0.5}
                strokeColor="#2ecc71"
                trailColor="#f2f2f2"
              />
            </div>
          </div>
        ) : (
          workshop.workshopSections.length > 0 &&
          !props.isArchived && (
            <div className="text-right" style={{ paddingTop: "10px" }}>
              {!loading && (
                <button
                  className="app-button"
                  onClick={() => {
                    setLoading(true);
                    appUser.startLearning(
                      workshop.id,
                      () => {
                        workshop.setSelectedSubSection(
                          workshop.workshopSections[0]
                        );
                        setLoading(false);
                      },
                      () => {
                        setLoading(false);
                      }
                    );
                  }}
                >
                  Start learning
                </button>
              )}
              <PulseLoader size={15} color={"#006699"} loading={loading} />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default PageHeader;
